<template>
    <div class="w-full grid-margin">
        <div v-if="Object.keys(open_sick_leaves).length > 0" class="card mb-4">
            <div class="card-body">
                <div class="card-title">Nieuwe verlofaanvragen</div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Medewerker</th>
                            <th>Begin-/einddatum en -tijd</th>
                            <th>Uren</th>
                            <th>Verklaring</th>
                            <th class="text-right">Acties</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr :ref="'open' + key" v-for="(value, key) in open_sick_leaves" :key="key">
                                <td>
                                    <button class="btn btn-primary btn-sm" type="button" data-toggle="modal" v-bind:data-target="'#show' + value['id']"><i class="fas fa-search"></i></button>
                                </td>
                                <td>{{ value['profile_name'] }}</td>
                                <td>
                                    {{ value['start_time'] }} <b>/</b> {{ value['start_date'] }}
                                    <br>
                                    <br>
                                    {{ value['end_time'] }} <b>/</b> {{ value['end_date'] }}
                                </td>
                                <td><b>{{ value['hours'] }}</b> uur</td>
                                <td>
                                    <p class="mb-0 line-height-16 ws-normal">
                                        {{ value['explanation'] }}
                                    </p>
                                </td>
                                <td>
                                    <div class="flex justify-end text-gray">
                                        <div @click="judge_sick_leave(key, 3, 'open')" :class="{'text-success': company_demo_not_expired}" class="cursor-pointer mr-3">
                                            <i class="fas fa-check font-size-20 p-1"></i>
                                        </div>
                                        <div @click="judge_sick_leave(key, 2, 'open')" :class="{'text-danger': company_demo_not_expired}" class="cursor-pointer">
                                            <i class="fas fa-times font-size-20 p-1"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="flex justify-between mb-4">
                    <div class="card-title">Verlofaanvragen</div>
                    <div class="flex">
                        <div class="flex align-items-center mr-4">
                            <div class="bg-success mr-2 info-cube"></div>
                            <span>Geaccepteerd</span>
                        </div>
                        <div class="flex align-items-center">
                            <div class="bg-danger mr-2 info-cube"></div>
                            <span>Afgewezen</span>
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Medewerker</th>
                                <th>Begin-/einddatum en -tijd</th>
                                <th>Uren</th>
                                <th>Toelichting</th>
                                <th class="text-right">Acties</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :ref="key" v-bind:class="{'bg-success' : value['status'] === 3, 'bg-danger' : value['status'] === 2}" v-if="!open_sick_leaves[key]" v-for="(value, key) in all_sick_leaves" :key="key">
                                <td>
                                    <button class="btn btn-primary btn-sm" type="button" data-toggle="modal" v-bind:data-target="'#show' + value['id']"><i class="fas fa-search"></i></button>
                                </td>
                                <td>{{ value['profile_name'] }}</td>
                                <td>
                                    {{ value['start_time'] }} <b>/</b> {{ value['start_date'] }}
                                    <br>
                                    <br>
                                    {{ value['end_time'] }} <b>/</b> {{ value['end_date'] }}
                                </td>
                                <td><b>{{ value['hours'] }}</b> uur</td>
                                <td>
                                    <p class="mb-0 line-height-16 ws-normal">
                                        {{ value['explanation'] }}
                                    </p>
                                </td>
                                <td>
                                    <div class="flex justify-end text-gray">
                                        <div @click="judge_sick_leave(key, 3, '')" v-bind:class="{'text-success' : value['status'] === 2 && company_demo_not_expired}" class="cursor-pointer mr-3">
                                            <i class="fas fa-check font-size-20 p-1"></i>
                                        </div>
                                        <div @click="judge_sick_leave(key, 2, '')" v-bind:class="{'text-danger' : value['status'] === 3 && company_demo_not_expired}" class="cursor-pointer">
                                            <i class="fas fa-times font-size-20 p-1"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
    export default {
        props: {
            open_sick_leaves: {},
            all_sick_leaves: {},
            company_demo_not_expired: {}
        },
        methods:
        {
            judge_sick_leave(key, status, origin)
            {
                if(this.company_demo_not_expired)
                {
                    let ref_key = origin + key;

                    if(status === 2) {
                        this.$refs[ref_key][0].classList = 'bg-danger';
                        this.$refs[ref_key][0].children[5].children[0].children[0].classList.add('text-success');
                        this.$refs[ref_key][0].children[5].children[0].children[1].classList.remove('text-danger');
                    } else {
                        this.$refs[ref_key][0].classList = 'bg-success';
                        this.$refs[ref_key][0].children[5].children[0].children[0].classList.remove('text-success');
                        this.$refs[ref_key][0].children[5].children[0].children[1].classList.add('text-danger');
                    }

                    let axios = require('axios');
                    let id;

                    if (this.all_sick_leaves[key]) {
                        id = this.all_sick_leaves[key]['id'];
                    } else {
                        id = this.open_sick_leaves[key]['id'];
                    }

                    axios.put('/employer/absences/' + id, {
                        status: status === 2 ? status : 3
                    });
                }
            },
            clickedRecord() {
                console.log(this.open_sick_leaves)
            }
        }
    }
</script>
